

















































import { Component, Prop, Vue } from "vue-property-decorator";
import OfferLineItem from "@/models/OfferLineItem";
import { ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationProvider
  }
})
export default class SubmissionFormOfferLineItems extends Vue {
  @Prop() private offerLineItems!: Array<OfferLineItem>;
  formatter = new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN"
  });

  get totalNetPrice() {
    return this.offerLineItems.reduce(
      (accum, item) => accum + item.netPrice,
      0
    );
  }
}
